import React from "react";
import Navigation from "./components/Navigation";
import Footer from "./components/footer";

import "./App.css";
import { ItemProvider } from "./context/ItemContext";

function App() {
  return (
    <ItemProvider>
      <div className='App'>
        <header>
          <Navigation />
        </header>
        <Footer />
      </div>
    </ItemProvider>
  );
}

export default App;
